import React, { useRef, useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { useBreakpoint } from '@americanexpress/aqx-components';
import DynAppBanner from 'src/universal/components/DynamicAppBanner';
import DynamicAppModal from 'src/universal/components/DynamicApp/DynamicAppModal';
import Desktop from './Desktop';
import Mobile from './Mobile';
import { DynamicAppModalContext } from 'src/universal/components/DynamicApp/redux';
import { getDynAppModalContent } from 'src/universal/components/DynamicApp/redux';
import { getCombinedG176Data } from './redux';
import { getActiveFilter } from 'src/universal/redux/cardsFilter';
import preloadImages from 'src/universal/utils/preloadImages';
import styles from './__styles__/index.scss?modules';
import dynAppBannerStyles from './__styles__/dynAppBanner.scss?modules';

const breakpointValMap = { sm: 'mobile', md: 'tablet', lg: 'desktop' };

const getBackImgUrl = (breakPointVal, assetList) => {
  const code = breakpointValMap[breakPointVal] || 'desktop';
  const asset = assetList.find(item => {
    return item.type === code;
  });
  return asset.url;
};

const getAllImgUrlsByBreakPoint = (breakPointVal, staticData) => {
  const code = breakpointValMap[breakPointVal] || 'desktop';
  const result = [];
  (staticData?.content || []).forEach(item => {
    const asset = (item.assets || []).find(asset => {
      return asset.type === code;
    });
    if (asset?.url) {
      result.push(asset.url);
    }
  });
  return result;
};

const DynamicHero = ({
  isG176Variant,
  staticG176Data,
  content,
  activeFilter,
  dynAppModalContent
}) => {
  const ctaRefFromBanner = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleDynAppModalOpen = useCallback(() => setIsModalOpen(prev => !prev), []);
  const { current } = useBreakpoint();

  useEffect(
    () => {
      // we ONLY preload the images for the current breakpoint.
      const imgList = getAllImgUrlsByBreakPoint(current, staticG176Data);
      preloadImages(imgList);
    },
    [current]
  );

  if (!isG176Variant) {
    return null;
  }

  const { header, title, assets } = content || {};
  const { dynamicAppBanner } = staticG176Data || {};
  const backImgUrl = getBackImgUrl(current, assets);
  const sharedProps = { title, header, backImgUrl };

  return (
    <>
      <div className={clsx(styles.dynamicHero, styles[`${activeFilter}`])}>
        {current === 'sm' && <Mobile {...sharedProps} />}
        {current !== 'sm' && <Desktop {...sharedProps} />}
      </div>
      <DynamicAppModalContext.Provider value={toggleDynAppModalOpen}>
        <DynAppBanner
          bannerDataInjected={dynamicAppBanner}
          custStyles={dynAppBannerStyles}
          ctaRef={ctaRefFromBanner}
        />
        <DynamicAppModal
          modal={isModalOpen}
          toggle={toggleDynAppModalOpen}
          content={dynAppModalContent}
          buttonRef={ctaRefFromBanner}
        />
      </DynamicAppModalContext.Provider>
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...getCombinedG176Data(state),
    activeFilter: getActiveFilter(state),
    dynAppModalContent: getDynAppModalContent(state)
  };
};

export default connect(mapStateToProps)(React.memo(DynamicHero));
